var exports = {
  "KE": "AdvancedSettingsTab.module__toolbar___M0p6bW",
  "uW": "AdvancedSettingsTab.module__section___M0p6bW",
  "bV": "AdvancedSettingsTab.module__sectionHeader___M0p6bW",
  "sq": "AdvancedSettingsTab.module__sectionTitleRow___M0p6bW",
  "Gf": "AdvancedSettingsTab.module__sectionTitle___M0p6bW",
  "yV": "AdvancedSettingsTab.module__sectionDescription___M0p6bW",
  "_R": "AdvancedSettingsTab.module__itemList___M0p6bW",
  "rd": "AdvancedSettingsTab.module__settingRow___M0p6bW",
  "gP": "AdvancedSettingsTab.module__settingRowFullWidth___M0p6bW",
  "cY": "AdvancedSettingsTab.module__settingMain___M0p6bW",
  "Gn": "AdvancedSettingsTab.module__settingMainInteractive___M0p6bW",
  "jF": "AdvancedSettingsTab.module__settingTitleRow___M0p6bW",
  "h3": "AdvancedSettingsTab.module__settingTitle___M0p6bW",
  "jg": "AdvancedSettingsTab.module__settingDescription___M0p6bW",
  "D9": "AdvancedSettingsTab.module__settingAction___M0p6bW",
  "kN": "AdvancedSettingsTab.module__settingActionFullWidth___M0p6bW",
  "lv": "AdvancedSettingsTab.module__controlStackCompact___M0p6bW",
  "p$": "AdvancedSettingsTab.module__emptyState___M0p6bW",
};

module.exports = exports;
